import React from "react";
import {Credits} from "../components/creditloader";
import {Carousel} from "../components/carousel";
import "../styleSheets/homeStyle.css";
import {Showreel} from "../components/showreel";
import {Reviews} from "../components/testimonials";
import {useImages} from "../components/useImages";
const Home = () => {
    return (
        <div className={"page"}>
            <section className={"hero-band metal"}>
                <Carousel />
            </section>

                <h2 style = {{color:'white'}}>See Our Showreels!</h2>
                <Showreel slides={useImages("showreel", "id")}/>

            <section>
                <Reviews />
            </section>
            <section >
                <h2 style={{color: 'white'}}>Most Recent Credits</h2>
                <Credits type="home" />
                <div className={"buttonContainer"}>
                    <a className="seeMoreButton" href={"/credit_page"}>See More</a>
                </div>
            </section>
        </div>
    );
};

export default Home;